import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToServices = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.querySelector('#servicios');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="bg-brand-cream" data-id="element-165">
      {/* Full Banner — shown complete, never cropped on any screen */}
      <div className="w-full bg-brand-mocha" data-id="element-166">
        <img src="https://cdn.magicpatterns.com/uploads/obCKydY6NwGSWNg3VpxNwg/banner.png" alt="CF Studio — Candelaria Fernandez" className="w-full h-auto object-contain" data-id="element-167" />
      </div>

      {/* Content below the banner */}
      <div className="container mx-auto px-6 text-center py-12 md:py-16" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-169">
          <h1 className="text-brand-mocha text-2xl md:text-4xl font-serif font-medium mb-3 text-balance" data-id="element-170">
            Uñas & Cuidado Capilar · 7 Años de Experiencia
          </h1>
          <p className="text-brand-mocha/70 text-sm md:text-base tracking-wide mb-8" data-id="element-171">
            Malvín, Erevan 1770 · Montevideo, Uruguay
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-172">
            <a href="https://cfstudio.koob.uy" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-3.5 bg-brand-rose text-white rounded-full font-medium transition-all hover:bg-brand-rose/90 hover:scale-105 active:scale-95" data-id="element-173">
              Agendar Turno
            </a>
            <a href="#servicios" onClick={scrollToServices} className="w-full sm:w-auto px-8 py-3.5 bg-transparent border border-brand-mocha/30 text-brand-mocha rounded-full font-medium transition-all hover:bg-brand-mocha/5" data-id="element-174">
              Ver Servicios
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}